@if (type() && control && formType() === 'text-input') {
  <mat-form-field class="{{ additionalClass() }}">
    <mat-label  [ngClass]="{
      'text-red': control.invalid && (control.dirty || control.touched)
    }">{{ label() }}</mat-label>
    <!--
      Two input variants. ngx-mask (attached via the `mask` attribute) becomes the value accessor and
      only repaints the DOM on a programmatic patchValue when a mask is actually set; without one, a
      post-render patchValue updated the model but left the box blank on OnPush (e.g. wizard prefills).
      When there is no mask we render a plain input so Angular's DefaultValueAccessor drives it — it
      writes the value straight to the DOM via Renderer2, so programmatic writes reflect reliably.
      Masked / money / phone fields keep ngx-mask unchanged.
    -->
    @if (maskComputed()) {
      <input
        matInput
        [type]="type() === 'password' && hide ? 'password' : 'text'"
        [autocomplete]="autocomplete()"
        [value]="value"
        [formControl]="control"
        [mask]="maskComputed()"
        [thousandSeparator]="type() === 'money' ? ',' : ''"
        [prefix]="type() == 'money' ? (prefix() ?? prefixComputed() ?? '') : ''"
        [attr.disabled]="disabled"
        [step]="stepComputed()"
        [min]="minComputed()"
        [max]="max()"
        [dropSpecialCharacters]="specialCharaters() || false"
        [pattern]="patternComputed()"
        [readonly]="readonly()"
        [placeholder]="placeholder()"
        [ngClass]="{
          'text-center': alignment() === 'center',
          'text-left': alignment() === 'left',
          'text-right': alignment() === 'right'
        }"
        />
    } @else {
      <input
        matInput
        [type]="type() === 'password' && hide ? 'password' : 'text'"
        [autocomplete]="autocomplete()"
        [formControl]="control"
        [attr.disabled]="disabled"
        [step]="stepComputed()"
        [min]="minComputed()"
        [max]="max()"
        [pattern]="patternComputed()"
        [readonly]="readonly()"
        [placeholder]="placeholder()"
        [ngClass]="{
          'text-center': alignment() === 'center',
          'text-left': alignment() === 'left',
          'text-right': alignment() === 'right'
        }"
        />
    }
      @if (startHint()) {
        <mat-hint align="start"
          ><strong>{{ startHint() }}</strong></mat-hint
          >
      }
      @if (endHint()) {
        <mat-hint align="end"
          ><strong>{{ endHint() }}</strong></mat-hint
          >
        }
        @if (suffix()) {
          <button matSuffix type="button" class="showpassword" (click)="showPasswordHandler()">
            <lib-icon matSuffix  [icon]="suffix() ?? ''"></lib-icon>
          </button>
        }
        @if (showError && control.hasError('required')) {
          <mat-error [id]="''">Required</mat-error>
        }
        @if (control.hasError('email')) {
          <mat-error [id]="''">Must be a valid email</mat-error>
        }
        @if (control.hasError('pattern')) {
          <mat-error>{{ patternErrorMessageComputed() }}</mat-error>
        }
        @if (control.hasError('min')) {
          <mat-error [id]="''">{{ minError() }}</mat-error>
        }
        @if (control.hasError('max')) {
          <mat-error [id]="''">{{ maxError() }}</mat-error>
        }
        @if (control.hasError('minlength')) {
          <mat-error [id]="''">Min {{ control.getError('minlength')?.requiredLength || '' }} Characters</mat-error>
        }
        @if (control.hasError('maxlength')) {
          <mat-error [id]="''">Max {{ control.getError('maxlength')?.requiredLength }} Characters</mat-error>
        }
        @if (control.hasError('message')) {
          <mat-error [id]="''">{{ control.getError('message') }}</mat-error>
        }
        @if (control.hasError('equalTo')) {
          <mat-error [id]="''">Passwords do not match</mat-error>
        }
      </mat-form-field>
    }


    @if (type() && control && formType() === 'search-input') {
      <!-- Same masked / non-masked split as text-input above so programmatic writes repaint. -->
      @if (maskComputed()) {
        <input
          [type]="type() === 'password' && hide ? 'password' : 'text'"
          [autocomplete]="autocomplete()"
          [value]="value"
          [formControl]="control"
          [mask]="maskComputed()"
          [thousandSeparator]="type() === 'money' ? ',' : ''"
          [prefix]="type() == 'money' ? (prefix() ?? prefixComputed() ?? '') : ''"
          [attr.disabled]="disabled"
          [step]="stepComputed()"
          [min]="minComputed()"
          [max]="max()"
          [dropSpecialCharacters]="specialCharaters() || false"
          [pattern]="patternComputed()"
          [readonly]="readonly()"
          [placeholder]="placeholder()"
        [ngClass]="{
          'text-center': alignment() === 'center',
          'text-left': alignment() === 'left',
          'text-right': alignment() === 'right'
        }"
          />
      } @else {
        <input
          [type]="type() === 'password' && hide ? 'password' : 'text'"
          [autocomplete]="autocomplete()"
          [formControl]="control"
          [attr.disabled]="disabled"
          [step]="stepComputed()"
          [min]="minComputed()"
          [max]="max()"
          [pattern]="patternComputed()"
          [readonly]="readonly()"
          [placeholder]="placeholder()"
        [ngClass]="{
          'text-center': alignment() === 'center',
          'text-left': alignment() === 'left',
          'text-right': alignment() === 'right'
        }"
          />
      }
        @if (startHint()) {
          <mat-hint align="start"
            ><strong>{{ startHint() }}</strong></mat-hint
            >
        }
        @if (endHint()) {
          <mat-hint align="end"
            ><strong>{{ endHint() }}</strong></mat-hint
            >
          }
          @if (suffix()) {
            <button matSuffix type="button" class="showpassword" (click)="showPasswordHandler()">
              <lib-icon matSuffix  [icon]="suffix() ?? ''"></lib-icon>
            </button>
          }
        }